import { render, staticRenderFns } from "./clubAdd.vue?vue&type=template&id=1199f6a4"
import script from "./clubAdd.vue?vue&type=script&lang=js"
export * from "./clubAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports